<div
  class="account-menu-container"
  ngbDropdown
  #accountDropdown="ngbDropdown"
  [autoClose]="true"
  placement="top-end"
>

  <div
    class="account-menu-trigger"
    [class.dropdown-disabled]="!isExpanded()"
  >
    <div
      *ngIf="isExpanded(); else collapsedAvatar"
      class="account-card"
      (click)="onAccountMenuClick($event)"
    >
      <div class="plan-title">
        {{ isDemoAccount ? 'Team Talonic' : (isFreemiumUser ? 'Free Trial' : 'Your Plan') }}
      </div>
      <div class="credits-progress" aria-hidden="true">
        <div
          class="credits-progress-bar"
          [style.width.%]="getCreditProgress()"
        ></div>
      </div>
      <div class="credits-left">
        {{ userInfo.credits || 0 }} Credits left
      </div>
      <div class="user-row">
        <div class="avatar">
          <img
            *ngIf="userInfo.avatar"
            [src]="userInfo.avatar"
            alt="User Avatar"
            class="avatar-img"
          />
          <div *ngIf="!userInfo.avatar" class="avatar-fallback">
            {{ getUserInitial() }}
          </div>
        </div>
        <div class="user-meta">
          <div class="user-name truncate" [title]="userInfo.firstName + ' ' + userInfo.lastName">
            {{ userInfo.firstName }} {{ userInfo.lastName }}
          </div>
          <div class="user-email truncate" [title]="userInfo.email">{{ userInfo.email }}</div>
        </div>
      </div>
    </div>

    <ng-template #collapsedAvatar>
      <div class="avatar avatar-collapsed" (click)="onAccountMenuClick($event)">
        <img
          *ngIf="userInfo.avatar"
          [src]="userInfo.avatar"
          alt="User Avatar"
          class="avatar-img"
        />
        <div *ngIf="!userInfo.avatar" class="avatar-fallback">
          {{ getUserInitial() }}
        </div>
      </div>
    </ng-template>
  </div>
  <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
    <a
      href="mailto:info@talonic.ai?subject=I%20need%20help:%20support%20request"
      class="help-section dropdown-item"
      data-umami-event="Get Help"
    >
      <img src="../../../../assets/img/icons/get_help.svg" alt="Help" />
      Get Help
    </a>
    <a class="logout-section dropdown-item" (click)="logout()">
      <img src="../../../assets/img/icons/logout.svg" />
      <span class="align-middle" data-key="t-logout">Log out</span>
    </a>
  </div>
</div>
